module.exports = __webpack_public_path__ + "static/media/f4-wide.bb71a5dd.jpg";